 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		82: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","3":"ibdPage","5":"legacyIbdPage","7":"ad-AdContainer","8":"components-analytics-analytics","9":"components-feature_feed-feature_feed","10":"container","11":"fc_executive_board","12":"fc_link-fc_link","13":"post-content-body","14":"aboutUsWpPage","15":"author","16":"category_page","17":"components-not_found_component-not_found_component","18":"components-slug-slug","19":"customCollectionPage","20":"feed","21":"loginPage","22":"logoutPage","23":"magazineTagPage","24":"magazine_page","25":"myAccountPage","26":"newsletters_page_marketo","27":"notFoundPage","28":"offerPage","29":"playlistIndexPage","30":"playlistPage","31":"podcastPage","32":"post_page","33":"registerPage","34":"resetPasswordPage","35":"sitemapIndex","36":"sitemapPost","37":"stories","38":"subscribePage","39":"tagPage","40":"videoIndex","41":"videoPage","42":"views-containers-layouts-blank_layout-blank_layout","43":"views-containers-layouts-web_layout-web_layout","77":"MarketoNewsletterForm","78":"MicCarousel","79":"MicIcon","80":"MicMobileIconCarousel","81":"Success-SubmissionSuccess","83":"applications-most-innovative-companies","84":"brands_that_matter_list_page","85":"brands_that_matter_page","86":"categoryLink","87":"components-BackgroundHighlight-BackgroundHighlight","88":"components-MultiTabList-MultiTabList","89":"components-QuickCarousel-QuickCarousel","90":"components-StickyBar-StickyBar","91":"components-all_feed-all_feed","92":"components-categories","93":"components-config-config","94":"components-editor_highlights-editor_highlights","95":"components-finite_scroll","96":"components-footer-footer","97":"components-franchise_intro-franchise_intro","98":"components-ibd_category-ibd_category","99":"components-image-image","100":"components-magazine_archive-magazine_archive","101":"components-masthead-masthead","102":"components-mcp_section-mcp_section","103":"components-mic_mobile_menu-mic_mobile_menu","104":"components-more-stories-component-more-stories-component","105":"components-newsletters-recaptcha","106":"components-notice","107":"components-piano-pianoBottomBanner","108":"components-podcast_tile-podcast_tile","109":"components-podcast_tile-podcast_tile_featured","110":"components-post-content-insert","111":"components-ranked","112":"components-recirc-recirc","113":"components-related_posts-related_posts","114":"components-related_slider-related_slider","115":"components-sectors_list-sectors_list","116":"components-social","117":"components-social-social","118":"components-top_50-top_50","119":"components-top_50_shuffle-top_50_shuffle","120":"components-video_megatron-video_megatron","121":"components-video_module-utils-video_module_ads","122":"components-video_module-video_module","123":"containers-pages-list_landers-bwi-2020","124":"containers-pages-list_landers-ibd-2020","125":"containers-pages-list_landers-mic-2021","126":"content-innovation_festival_banner","127":"content-sponsor_bar","128":"fc-components-main-components","129":"fc-components-main-components-StickyBar-StickyBar","130":"fc-components-main-containers","131":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","132":"fc-components-main-containers-IbdLayout-IbdLayout","133":"fc-components-main-containers-WciLayout-WciLayout","134":"fc-components-main-utils-ConditionalWrapper","135":"franchises-BtmApplyPage","136":"franchises-BwiApplyPage","137":"franchises-IbdApplyPage","138":"franchises-MicApplyPage","139":"franchises-NbttApplyPage","140":"franchises-WciApplyPage","141":"innovation_by_design_future_page","142":"innovation_by_design_page_franchise","143":"innovation_by_design_page_franchise_2023","144":"layouts","145":"layouts-mcp","146":"nav_main_menu-nav_main_menu","147":"package_article_list_entry","148":"packages-nav-package_sticky_nav","149":"post-content-sidebar"}[chunkId]||chunkId) + "." + {"1":"8a675ae1890e31fd742b","2":"b668fb2f69d25970da58","3":"1f6a896711086333556d","4":"648d95fe66f930bcce89","5":"8ea08974a06e614b1a00","6":"795140ea4fa0ebc06a7f","7":"b048baebd2b5bdce1f6e","8":"57aa74311bcbcf5e8417","9":"6aa10e7f51dc79dea958","10":"2091c9977485dbf4aaa7","11":"f7d630ed04320a200d2e","12":"ac302b03ad75f361b5ad","13":"1159a54a1f51dea392da","14":"318a7a8eb0aa23455300","15":"3cbe7da51e0acf2648a5","16":"507c85531fee4ec7bc4d","17":"9692a79ca4f80aced7e6","18":"998193735793f70ffbf9","19":"0c8312096d0d0c785fc4","20":"a4abbe1807b269ab77fa","21":"7829a0eaca19161f990d","22":"caf5311649ee69cea13b","23":"06ce3fe2740d5312f01e","24":"03ee0ae5e756a6752969","25":"e98f1ab2fb178dfc427e","26":"b3d54efb0327efe451ca","27":"e247463bc9af0b291032","28":"52b2e370a68317a62832","29":"4355769a84e7f7493ba5","30":"6b1d246eaa9926e0a6a7","31":"2351f54ce4dfa03a964a","32":"63d36ef95cecfb8c69a2","33":"7d13c4a2543bfd124a54","34":"38083012a2b950f6e5c6","35":"baeac7bca6ee46bb1828","36":"d9835551a54b4bc590d5","37":"5f58b9344e655f7ae46a","38":"6262bd462c93722523d2","39":"4fd3319ab1dd84ec67fd","40":"4d0b1bd1c0282aaa678a","41":"9a05b29eaaa49402789b","42":"9e8f17cf94e35976bdb4","43":"4a65d8956e37539bc639","44":"4393db436fdc1a50474a","45":"135a6137285e71022ae7","46":"7ea44c80fe6b6a2d3bdb","47":"4212ddda2873c27961d8","48":"2322c286c6e87002e403","49":"3ccf1e50b2c446a8e35e","50":"bff626caee45affb5c26","51":"6f3f97080b83c1bb0cf6","52":"3fc440ac4360636d6177","53":"61cdfd986d153499ee4e","54":"d3673268f3160e1f012d","55":"771bb9322df13e450883","56":"681d540eb960b823e01c","57":"669921ecbd20d172542d","58":"c580bb31bb33c6b527ad","59":"b0a88fbe107456e726f9","60":"492c58fbe8f160aacfb8","61":"b15d7303579321ff1e12","62":"e9f342ad3d3f9cc8315c","63":"1cb16686b816425fb451","64":"5807352bbf4cfffde9b4","65":"d0e9d6dcff692ba295bc","66":"bdb804647c7afb04a7db","67":"b089c7c4db9247e19ba9","68":"3ceb519a283845430d56","69":"5be85a8fb16734d8d066","70":"bebaf35d67558ad08c19","71":"5fed174ab028eb30377b","72":"197f1bf42ec7d21e22e6","73":"4ec83be9205edf9a79b2","74":"9e0b248fa6d5d85b9ffd","75":"c338969461f665309b24","76":"d8918b8560a02a3b18a6","77":"dbed1993a45de52cb7ac","78":"1a25a003ba8f12e77869","79":"228a30f1a3938daa9b8b","80":"e52527f299702973920a","81":"8baaa6d0f7d6dff643c6","83":"0285a1ce4a38b1486c9d","84":"e736b31ad7899c73a938","85":"32c021631ad9ab3dac7c","86":"4669baeb224bebe63126","87":"4a3d9e00a1d351929900","88":"6d9792be104c18838047","89":"d3726a88e7c60e198e84","90":"9d8b505caa2e16f2ed4c","91":"7f79f84a5a3555bd23de","92":"b93392ebd2bc8e4a25f9","93":"cb09cb1e29f3d26fea02","94":"2c1e45cf52132e88bc27","95":"7d8573641fe8c6e0a921","96":"ed6bef7c987298359bb8","97":"d6a4442127dedc7aa4bb","98":"daf189c7466cb5187b1b","99":"e7658189d2a126d61d50","100":"238e192e18d6184767c2","101":"2e3d98db06b98e5d6b0d","102":"d007935f850924a51547","103":"401eead4c63a3f689ace","104":"87685a02c3ad47fa2dc3","105":"640bb628f06d51059912","106":"95c6f1d669c99380d199","107":"a8bdad7d323f0baa58f1","108":"71c8c14943739a40de2b","109":"cbfe73d84f778593243f","110":"2c0e352dd6758170c711","111":"5ec9dcca662bd1d8e425","112":"ee55ab00b3ee4fe1c5df","113":"f577d4685a02ce07db0b","114":"8bde1a8329ad1136fc63","115":"3568f5c7fc9d38210aca","116":"8e461f021777b3eb2bf2","117":"9d9b432a0ab741f416e7","118":"6b3148ca30d70856b3ce","119":"a9b88296ce1891806689","120":"f61ca80533070de1a064","121":"2b9b4245ba218533173b","122":"dde46b46421bbde413d4","123":"38ee44ebb51a93d687ac","124":"428ae10abd436038fd98","125":"2586bd14dd461b56263b","126":"4a7a45598f40fd242de8","127":"f9a6ab237d9828082913","128":"9334fba8b685fd57de1f","129":"18e0190889e9f9a5ea12","130":"42577815fd25432929ba","131":"c7b6f1f2c92588da8f54","132":"5c0cce05a516355a9c5a","133":"89fb3d71481da7d07bc4","134":"f366d608049b82fddd93","135":"d3bd4edb23f024c1928d","136":"f582bfe5f9289a6afd28","137":"1baa2bdcfec4d6b180ce","138":"c37e907ed129ff00e413","139":"c82b8340ad1d5f1600f5","140":"f81b56a286db6767f035","141":"934d13a706e483873b7f","142":"118c046099ba2e706837","143":"5d9f9bc057cd5f707934","144":"3680aad1e619213ed99a","145":"0acaa01ee53e6c849a06","146":"dcb5964542f9b3b9c342","147":"1e270abaea1631da4d79","148":"b6aafe23e8d8b1a73b9a","149":"6f92ba84c4c166a808ad"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([745,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
